/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.assign.js";
import { Toast } from 'vant';
import * as repayService from '@/services/repay';
import formatAmount from '@/shared/formatAmount';
import TrackingData from '@/shared/reportDataTracking';
import { throttle } from '@/shared/watchScroll.js';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'payment',
    setup: function(__props) {
        var userStore = useUserStore();
        var route = useRoute();
        var onCopy = function(e) {
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                taskHandler: 'payment_screen_copy_click'
            }));
            console.log(e.text);
            Toast('Copiado con éxito');
        };
        var onError = function(e) {
            console.log(e);
        };
        var formKey = ref(Number(route.query.formKey));
        var payAllObj = reactive({
            allOutstandingBalance: 0,
            planDate: '',
            payBack: ''
        });
        var reqRepayCode = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var params, result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                formKey: formKey.value
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                repayService.queryRepayCode(params)
                            ];
                        case 2:
                            result = _state.sent();
                            console.log(result, 'queryRepayCode');
                            Object.assign(payAllObj, result);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqRepayCode() {
                return _ref.apply(this, arguments);
            };
        }();
        reqRepayCode();
        var oldScrollTop = ref(0);
        window.addEventListener('scroll', throttle(function() {
            var scrollTop = window.pageYOffset;
            console.log('scrollTop', scrollTop);
            if (scrollTop > oldScrollTop.value) {
                TrackingData.trackMove(_object_spread_props(_object_spread({}, userStore.commonData), {
                    taskHandler: 'payment_screen-move'
                }));
                window.removeEventListener('scroll', throttle);
            }
        }, 1000 * 60 * 60 * 24));
        onUnmounted(function() {
            window.removeEventListener('scroll', throttle);
        });
        return {
            __sfc: true,
            userStore: userStore,
            route: route,
            onCopy: onCopy,
            onError: onError,
            formKey: formKey,
            payAllObj: payAllObj,
            reqRepayCode: reqRepayCode,
            oldScrollTop: oldScrollTop,
            formatAmount: formatAmount
        };
    }
};
